import { render, staticRenderFns } from "./InspectionRecordDrawer.vue?vue&type=template&id=da4c8644&scoped=true&"
import script from "./InspectionRecordDrawer.vue?vue&type=script&lang=js&"
export * from "./InspectionRecordDrawer.vue?vue&type=script&lang=js&"
import style0 from "./InspectionRecordDrawer.vue?vue&type=style&index=0&id=da4c8644&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4c8644",
  null
  
)

export default component.exports